import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=74c9762c"
import script from "./appInfo.vue?vue&type=script&lang=js"
export * from "./appInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports